import { FlexRow, Button, Panel } from '@epam/promo';
import { IModal, useUuiContext } from '@epam/uui-core';
import css from './UserManagement.module.scss';
import { useUserGroupsGetQuery } from 'hooks/api/userGroups/useUserGroupsGetQuery';
import { FlexCell } from '@epam/uui-components';
import { UserGroup } from 'components/userGroupManagement/UserGroup';
import { UserGroupAddModal } from 'components/userGroupManagement/UserGroupAddModal/UserGroupAddModal';
import { useUserGroupCreateQuery } from 'hooks/api/userGroups';

export const UserGroupsManagementSubpage = () => {
  const { uuiModals } = useUuiContext();
  const { data: userGroupsData = [] } = useUserGroupsGetQuery();
  const { mutate: createUserGroup } = useUserGroupCreateQuery();

  const addGroup = () => {
    uuiModals
      .show<void>((modalProps: IModal<void>) => (
        <UserGroupAddModal
          modalProps={modalProps}
          onConfirm={(groupName, rolesList) =>
            createUserGroup({
              name: groupName,
              rolesList: rolesList.split(','),
            })
          }
        />
      ))
      .catch((e) => console.error(e));
  };

  return (
    <Panel shadow background="white" cx={css['group-container']}>
      <FlexRow cx={[css['group-header'], css.gap]}>
        <Button caption="Add Group" color="blue" onClick={addGroup} />
      </FlexRow>
      <FlexCell cx={[css.gap, css['group-list']]}>
        {userGroupsData.map((group) => (
          <UserGroup
            key={group.id}
            id={group.id}
            name={group.name}
            roles={group.roles}
          />
        ))}
      </FlexCell>
    </Panel>
  );
};
